/* eslint-disable */

// apps/src/util/color.js
// GENERATED FILE: DO NOT MODIFY DIRECTLY
// This generated file exports all variables defined in shared/css/color.scss
// for use in JavaScript. The generator script is convert-scss-variables.js
module.exports = {
  "black": "#000",
  "background_black": "#121416",
  "dark_gray": "#2D3139",
  "darkest_gray": "#292F36",
  "dark_slate_gray": "#282c34",
  "darkest_slate_gray": "#25292d",
  "dark_charcoal": "#4d575f",
  "charcoal": "#5b6770",
  "light_gray": "#949ca2",
  "lighter_gray": "#c6cacd",
  "lightest_gray": "#e7e8ea",
  "background_gray": "#f2f2f2",
  "dimgray": "#696969",
  "white": "#fff",
  "default_blue": "#3670b3",
  "dark_teal": "#0094a3",
  "teal": "#00adbc",
  "applab_button_teal": "#1abc9c",
  "light_teal": "#59cad3",
  "lightish_teal": "#80d6de",
  "lighter_teal": "#a6e3e8",
  "lightest_teal": "#d9f3f5",
  "purple": "#7665a0",
  "light_purple": "#a69bc1",
  "lighter_purple": "#cfc9de",
  "lightest_purple": "#ebe8f1",
  "cyan": "#0094ca",
  "light_cyan": "#59b9dc",
  "lighter_cyan": "#a6daed",
  "lightest_cyan": "#d9eff7",
  "almost_white_cyan": "#f5fcff",
  "orange": "#ffa400",
  "light_orange": "#ffc459",
  "lighter_orange": "#ffe0a6",
  "lightest_orange": "#fff2d9",
  "dark_orange": "#ff8600",
  "green": "#b9bf15",
  "light_green": "#d1d567",
  "lighter_green": "#e7e9ad",
  "lightest_green": "#f5f5dc",
  "highlight_green": "#8afc9b",
  "yellow": "#ffb81d",
  "light_yellow": "#ffdb74",
  "lighter_yellow": "#ffebb5",
  "lightest_yellow": "#fff7df",
  "goldenrod": "#daa520",
  "header_text": "#fff",
  "bkgnd_color": "#00adbc",
  "inset_color": "#c6cacd",
  "dark_color": "#7665a0",
  "hdr_color": "#7665a0",
  "red": "#c00",
  "lightest_red": "#fcc",
  "dark_red": "#d62911",
  "realgreen": "#008000",
  "realyellow": "#ff0",
  "mustardyellow": "#efcd1c",
  "twitter_blue": "#00aced",
  "facebook_blue": "#3b5998",
  "dark_blue": "#00647f",
  "blockly_flyout_gray": "#ddd",
  "default_text": "#333",
  "border_gray": "#bbb",
  "border_light_gray": "#d8d8d8",
  "table_header": "#ececec",
  "table_light_row": "#fcfcfc",
  "table_dark_row": "#f4f4f4",
  "level_submitted": "#7665a0",
  "level_perfect": "rgb(14, 190, 14)",
  "level_passed": "rgb(159, 212, 159)",
  "level_attempted": "#ff0",
  "level_not_tried": "#fefefe",
  "level_current": "#ffa400",
  "level_review_rejected": "#c00",
  "level_review_accepted": "rgb(11, 142, 11)",
  "assessment": "#0094ca",
  "workspace_running_background": "#e5e5e5",
  "dark_purple": "#682A77",
  "bright_green": "#0ebe0e",
  "neon_pink": "#e9118f",
  "link_color": "#0596ce",
  "shadow": "rgba(0, 0, 0, 0.3)",
  "bootstrap_button_blue": "#337ab7",
  "bootstrap_button_red": "#d9534f",
  "bootstrap_error_background": "#f2dede",
  "bootstrap_error_text": "#b94a48",
  "bootstrap_v3_error_text": "#a94442",
  "bootstrap_error_border": "#ebccd1",
  "bootstrap_warning_background": "#fcf8e3",
  "bootstrap_warning_text": "#c09853",
  "bootstrap_warning_border": "#faebcc",
  "bootstrap_border_color": "#cccccc",
  "bootstrap_success_background": "#dff0d8",
  "bootstrap_success_text": "#468847",
  "bootstrap_success_border": "#d6e9c6",
  "droplet_light_green": "#d3e965",
  "droplet_blue": "#64b5f6",
  "droplet_bright_blue": "#19c3e1",
  "droplet_yellow": "#fff176",
  "droplet_orange": "#ffb74d",
  "droplet_red": "#f78183",
  "droplet_cyan": "#4dd0e1",
  "droplet_pink": "#f57ac6",
  "droplet_purple": "#bb77c7",
  "droplet_green": "#68d995",
  "droplet_white": "#fff",
  "oceans_deep_blue": "rgb(2, 0, 28)",
  "dark_black": "#121212",
  "brand_primary_light": "#ABDFE5",
  "brand_primary_default": "#009EB0",
  "brand_primary_dark": "#008291",
  "brand_secondary_light": "#E0D1EC",
  "brand_secondary_default": "#9660BF",
  "brand_secondary_dark": "#6F488E",
  "brand_accent_default": "#ED6060",
  "product_affirmative_default": "#3EA33E",
  "product_negative_light": "#FDEBE9",
  "product_negative_default": "#E5311A",
  "product_negative_dark": "#AA2513",
  "product_caution_default": "#F9CB28",
  "product_information_default": "#007ACC",
  "neutral_white": "#FFFFFF",
  "neutral_light": "#F7F8FA",
  "neutral_dark10": "#EAEBEB",
  "neutral_dark20": "#D4D5D7",
  "neutral_dark30": "#BFC1C3",
  "neutral_dark40": "#A9ACAF",
  "neutral_dark50": "#94979B",
  "neutral_dark60": "#7F8286",
  "neutral_dark70": "#6A6E73",
  "neutral_dark80": "#54595E",
  "neutral_dark90": "#3F444B",
  "neutral_dark": "#292F36",
  "google_brand_color": "#0F9D58",
  "microsoft_brand_color": "#FFB900",
  "facebook_brand_color": "#3B5998",
  "light_primary_100": "#ABDFE5",
  "light_primary_500": "#0093A4",
  "light_primary_700": "#008291",
  "light_secondary_100": "#E2D4EE",
  "light_secondary_500": "#8C52BA",
  "light_secondary_700": "#6F488E",
  "light_gray_200": "#D4D5D7",
  "light_gray_300": "#BFC1C3",
  "light_gray_500": "#94979B",
  "light_gray_700": "#6A6E73",
  "light_affirmative_100": "#E2F1E2",
  "light_black": "#292F36",
};
